var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"e4bb47fb7ae8ff9e48d2b763b8e43e1c09852570"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["engine-frontend@apollograph"]={id:"e4bb47fb7ae8ff9e48d2b763b8e43e1c09852570"};
      